import script from "./BonusBallColorRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./BonusBallColorRow.vue?vue&type=script&setup=true&lang=ts"

import "./BonusBallColorRow.vue?vue&type=style&index=0&id=3d4e8473&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d4e8473"]])

export default __exports__